<template>
  <div class="content">
    <div class="bodycontent">
      <!-- 头部菜单 -->
      <div class="option">
        <div class="left">
          <el-button type="primary" @click="addAddress()">添加退货地址</el-button>
        </div>
        <div class="right">
          <!-- <span>
            <el-select v-model="type" placeholder="状态" clearable>
              <el-option label="真实" value="1"></el-option>
              <el-option label="虚拟" value="2"></el-option>
            </el-select>
          </span> -->
          <span>
            <el-input
              type="text"
              placeholder=""
              v-model="keyword"
              style="width:180px"
              clearable
            />
          </span>
          <span>
            <el-button type="primary" @click="search()">搜索</el-button>
          </span>
        </div>
      </div>
      <!-- 退货地址列表 -->
      <el-table :data="listData">
        <el-table-column label="名称" prop="title"></el-table-column>
        <el-table-column label="联系人" prop="name"></el-table-column>
        <el-table-column label="手机" prop="mobile"></el-table-column>
        <el-table-column label="地址">
          <template slot-scope="scope">
            <div class="table_line">{{scope.row.area}}</div>
            <div class="table_line">{{scope.row.address}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="120px">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row.id)">编辑</el-button>
            <el-button type="text" @click="delItem(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { BackAddressList, DelBackAddress } from "@/api/backAddress"
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      status: "", //状态筛选
      type: "", //类型筛选 
      listData: [], //列表
      keyword: "", //关键字筛选
      page: 1,
      total: 0,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(){
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        return_status: 1, //必填 回复状态检索 1需要首次回复 2需要追加回复
        start_time: this.start_time, //开始时间
        end_time: this.end_time, //结束时间
        type: this.type,
        keyword: this.keyword,
      }
      BackAddressList(data).then(res=>{
        console.log(res);
        this.listData = res.data;
        this.total = res.total;
      })
    },
    search() {
      this.page = 1;
      this.getData();
    },
    //添加退货地址
    addAddress(){
      this.$router.push('addBackAddress');
    },
    //跳页
    handleCurrentChange(p){
      this.page = p;
      this.getData();
    },
    //编辑
    editItem(id){
      this.$router.push({path:'addBackAddress',query:{aid:id}});
    },
    //删除
    delItem(i){
      this.$confirm('确定删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var data = {
          token:this.token,
          app_id:this.app_id,
          id:i
        }
        DelBackAddress(data).then(res=>{
          if(res.code == 200){
            this.$message({
              type:"success",
              message:"删除成功"
            })
            this.getData()
          }else{
            this.$message({
              type:"error",
              message: res.msg
            })
          }
        })
      }).catch();
    },
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    display: flex;
    flex-direction: column;
    .option {
      height: 79px;
      line-height: 79px;
      display: flex;
      .left {
        flex: 1;
      }
      .right {
        text-align: right;
        span{
          margin-left: 10px;
          .el-select{
            width:150px;
          }
        }
      }
    }
    // table
    .el-table {
      flex:1;
      box-shadow: 0 0 3px #f1f1f1;
      padding-left: 10px;
    }
    //表格中的商品内容
    .table_line{
      height: 20px;
      line-height: 20px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
    }
    //分页
    .Otherpage {
      height: 34px;
      width: 200px;
      line-height: 34px;
    }
  }
}
</style>
